export function downloadFile(url: string, filename?: string) {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.download = filename || 'Untitled';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function downloadImage(url: string, filenameBase = 'download') {
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) console.error(`Fetch failed: ${res.statusText}`);
    const blob = await res.blob();
    const ext = blob.type.split('/')[1] || 'png';
    const finalName = `${filenameBase}`;

    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = finalName;
    // **Important**: no target
    link.removeAttribute('target');
    // add to DOM, click, remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  } catch (err) {
    console.error('downloadImage error', err);
  }
}
